var map = {
	"./1.png": 72738,
	"./10.png": 85688,
	"./11.png": 6817,
	"./12.png": 49386,
	"./13.png": 81299,
	"./14.png": 83900,
	"./15.png": 19813,
	"./2.png": 86745,
	"./3.png": 54640,
	"./4.png": 66863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10283;